import styled, { css } from 'styled-components';
import { SPACING } from '../../styles/spacing';
import { FONT_SIZES } from '../../styles/typography';
import { INPUT_HEIGHT } from '../../styles/typography';
import { mainTheme } from '@plecto/ui';

// Colours only — no sizing. Bare inputs in this package get their box from the
// app's .form-control, and only need the palette pointed at the design tokens.
export const inputColors = css`
	color: ${mainTheme.form.input.color};
	background-color: ${mainTheme.form.input.background};
	border: ${mainTheme.form.border.width}px solid ${mainTheme.form.input.border};
	border-radius: ${mainTheme.form.border.radius}px;

	&::placeholder {
		color: ${mainTheme.form.input.placeholderColor};
	}

	&:focus {
		border-color: ${mainTheme.form.input.focus.border};
		outline: 0;
		box-shadow: ${mainTheme.form.input.focus.shadow};
	}

	&:disabled {
		background-color: ${mainTheme.form.disabled.background};
		opacity: ${mainTheme.form.disabled.opacity};
	}
`;

export const Input = styled.input`
	${inputColors}
	display: block;
	width: 100%;
	height: ${INPUT_HEIGHT};
	padding: ${SPACING.smaller} ${SPACING.small};
	font-size: ${FONT_SIZES.big};

	${props => props.error ? css`
		border-color: ${mainTheme.form.input.error.border};

		&:focus {
			border-color: ${mainTheme.form.input.error.border};
			box-shadow: ${mainTheme.form.input.error.shadow};
		}
	` : ''}
`;
